import { render, staticRenderFns } from "./NewDashboard.vue?vue&type=template&id=19f7ece6&scoped=true&"
import script from "./NewDashboard.vue?vue&type=script&lang=js&"
export * from "./NewDashboard.vue?vue&type=script&lang=js&"
import style0 from "./NewDashboard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewDashboard.vue?vue&type=style&index=1&id=19f7ece6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f7ece6",
  null
  
)

export default component.exports